import { MyTodos } from "./taskboard/TaskboardTables/MyTodos";
import { MyFollowup } from "./taskboard/TaskboardTables/MyFollowup";
import { MyTask } from "./taskboard/TaskboardTables/MyTask";
import { useState } from "react";
import useLocalStorageState from "use-local-storage-state";
import { CheckSquare, LucideCalendar } from "lucide-react";
import { IconCalendarEvent, IconListCheck, IconLayoutDashboard, IconBriefcase } from "@tabler/icons-react";
import { TaskBoardMeeting } from "./taskboard/TaskboardTables/TaskBoardMeeting";
import { useDebounce } from "../../Utils/helpers/commonhelper";
import { MyDashboard } from "./myDashboard/MyDashboard";
import { CEODashboard } from "./ceoDashboard/CEODashboard";
import { FinancialDashboard } from "./financialDashboard/FinancialDashboard";
import { MarketingDashboard } from "./marketingDashboard/MarketingDashboard";
import { SalesManagerDashboard } from "./salesManagerDashboard/SalesManagerDashboard";

const DEFAULT_DASHBOARD_VIEW = "ceo_dashboard";

const DASHBOARD_VIEWS = [
    { id: 'my_dashboard', label: 'My Dashboard', icon: <LucideCalendar size={16} /> },
    { id: 'my_taskboard', label: 'My Taskboard', icon: <CheckSquare size={16} /> },
    { id: 'ceo_dashboard', label: 'CEO Dashboard', icon: <IconLayoutDashboard size={16} /> },
    { id: 'marketing_dashboard', label: 'Marketing Dashboard', icon: <IconBriefcase size={16} /> },
    { id: 'financial_dashboard', label: 'Financial Dashboard', icon: <IconBriefcase size={16} /> },
    { id: 'sales_dashboard', label: 'Sales Dashboard', icon: <IconBriefcase size={16} /> },
    // { id: 'sales_manager_dashboard', label: 'Sales Manager', icon: <IconBriefcase size={16} /> },
];

const DASHBOARD_VIEW_IDS = new Set(DASHBOARD_VIEWS.map((view) => view.id));

export const Dashboard = () => {
    const [storedActiveDashboard, setActiveDashboard] = useLocalStorageState(
        "dashboardActiveView",
        DEFAULT_DASHBOARD_VIEW
    );
    const activeDashboard = DASHBOARD_VIEW_IDS.has(storedActiveDashboard)
        ? storedActiveDashboard
        : DEFAULT_DASHBOARD_VIEW;

    const dashboardLabel =
        DASHBOARD_VIEWS.find((view) => view.id === activeDashboard)?.label ?? "CEO Dashboard";

    // Taskboard tab state management
    const [activeTab, setActiveTab] = useState('followup');

    // Search state
    const [inputSearch, setInputSearch] = useState("");
    const debouncedInputSearch = useDebounce(inputSearch, 200);

    const dashboards = DASHBOARD_VIEWS;

    const taskboardTabs = [
        { id: 'followup', label: 'Follow Ups', icon: <LucideCalendar size={15} /> },
        { id: 'task', label: 'My Tasks', icon: <CheckSquare size={15} /> },
        { id: 'todos', label: 'My Todos', icon: <IconListCheck size={16} /> },
        { id: 'meeting', label: 'Meetings', icon: <IconCalendarEvent size={16} /> }
    ];

    // f3f3f3
    // f8fafc
    return (
        <div className="dashboard-wrapper px-4 py-3" style={{ background: "#f3f3f3", minHeight: "calc(100vh - 4rem)" }}>
            <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3 pb-3 mb-0" style={{ borderColor: "#e2e8f0" }}>
                <div>
                    <div className="d-flex align-items-center gap-2">
                        <h4 className="mb-0 fw-normal" style={{ color: "#1e293b", fontSize: "1.5rem" }}>
                            {dashboardLabel}
                        </h4>
                    </div>
                    <span className="text-muted d-block mt-0.5" style={{ fontSize: "0.825rem" }}>
                        Track your real-time sales activity and lead metrics.
                    </span>
                </div>
                <div className="d-flex align-items-center gap-1 p-1 rounded-4 shadow-sm" style={{ backgroundColor: "#ffffff", border: "1px solid #e2e8f0" }}>
                    {dashboards.map((tab) => {
                        const isActive = activeDashboard === tab.id;
                        return (
                            <button
                                key={tab.id}
                                onClick={() => setActiveDashboard(tab.id)}
                                className="btn d-flex align-items-center gap-2 px-3 py-1.5 transition-all"
                                style={{
                                    borderRadius: '1rem',
                                    fontSize: '12px',
                                    fontWeight: isActive ? '600' : '500',
                                    color: isActive ? '#ffffff' : '#64748b',
                                    backgroundColor: isActive ? '#7a3a5e' : 'transparent',
                                    border: 'none',
                                    boxShadow: isActive ? '0 2px 6px rgba(122, 58, 94, 0.25)' : 'none',
                                    textWrap: "nowrap"
                                }}
                            >
                                {tab.icon}
                                <span>{tab.label}</span>
                            </button>
                        );
                    })}
                </div>
            </div>
            <hr style={{ height: '0.1rem' }} className="my-0" />

            <div className="d-flex justify-content-between align-items-center">
                <div className={`d-flex flex-column rounded-4  mb-0 d-flex justify-content-between align-items-center ${activeDashboard === "my_taskboard" ? "py-2" : "py-0"}`}>
                    <div className="d-flex align-items-center justify-content-between w-100 gap-1 rounded-3">
                        <div className="d-flex align-items-center gap-1 ">
                            {
                                activeDashboard === "my_taskboard" &&
                                <div className="d-flex gap-2 p-1 ">
                                    {[
                                        { id: 'followup', label: 'Follow Ups', icon: <LucideCalendar size={16} /> },
                                        { id: 'task', label: 'My Tasks', icon: <CheckSquare size={16} /> },
                                        { id: 'todos', label: 'My Todos', icon: <IconListCheck size={18} /> },
                                        { id: 'meeting', label: 'Meetings', icon: <IconCalendarEvent size={18} /> }
                                    ].map((tab) => (
                                        <button
                                            key={tab.id}
                                            onClick={() => {
                                                setActiveTab(tab.id);
                                                // if (tab.id !== 'todos') setFilter(`All ${tab.id === "followup" ? "Followup" : "Task"}`);
                                            }}
                                            className={`btn d-flex align-items-center gap-2 px-3 py-2 transition-all ${activeTab === tab.id
                                                ? " shadow-sm  fw-medium"
                                                : "text-muted fw-medium border "
                                                }`}
                                            style={{
                                                borderRadius: '1rem',
                                                fontSize: '12px',
                                                color: activeTab === tab.id ? 'white' : '#64748b',
                                                // color: "black",
                                                // borderColor: activeTab === tab.id ? '#7a3a5e' : '#64748b',
                                                background: activeTab === tab.id ? '#7a3a5e' : 'white',
                                            }}
                                        >
                                            {tab.icon}
                                            {tab.label}
                                        </button>
                                    ))}
                                </div>
                            }
                        </div>
                    </div>
                </div>

                {
                    activeDashboard === "my_taskboard" &&
                    <div className=" position-relative " >
                        <input
                            type="text"
                            className="btn d-flex align-items-start border gap-2  py-2 transition-all"
                            style={{ fontSize: "0.87rem", fontWeight: 500, textAlign: "left", paddingLeft: "36px", height: '38px', borderRadius: "16px", background: "white" }}
                            value={inputSearch}
                            placeholder="Search Here...."
                            onChange={(e) => {
                                e.preventDefault()
                                setInputSearch(e.target.value)
                            }}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    e.preventDefault()
                                    setInputSearch(inputSearch)
                                }
                            }}
                        />
                        <i
                            class="fa-solid fa-magnifying-glass"
                            style={{
                                position: "absolute",
                                marginTop: "-26px",
                                zIndex: 1,
                                marginLeft: "13px",
                            }}
                        ></i>
                        {inputSearch.length > 0 && (
                            <i
                                class="fa-solid fa-xmark"
                                style={{
                                    position: "absolute",
                                    marginTop: "-26px",
                                    zIndex: 1,
                                    right: 0,
                                    marginRight: "13px",
                                    cursor: "pointer",
                                }}
                            // onClick={() => setInputSearch("")}
                            ></i>
                        )}
                    </div>

                }
            </div>

            <div className="content-container animate-fade-in" style={{ minHeight: "calc(100vh - 12rem)" }}>
                {activeDashboard === "ceo_dashboard" && <CEODashboard />}
                {activeDashboard === "my_dashboard" && <MyDashboard />}
                {activeDashboard === "marketing_dashboard" && <MarketingDashboard />}
                {activeDashboard === "financial_dashboard" && <FinancialDashboard />}
                {activeDashboard === "sales_dashboard" && <SalesManagerDashboard />}

                {activeDashboard === "my_taskboard" && (
                    <>
                        {activeTab === "followup" && <MyFollowup searchInput={debouncedInputSearch} />}
                        {activeTab === "task" && <MyTask searchInput={debouncedInputSearch} />}
                        {activeTab === "todos" && <MyTodos />}
                        {activeTab === "meeting" && <TaskBoardMeeting />}
                    </>
                )}
            </div>

            <style>{`
                .transition-all { transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1); }
                .animate-fade-in { animation: fadeIn 0.25s cubic-bezier(0.4, 0, 0.2, 1); }
                @keyframes fadeIn {
                    from { opacity: 0; transform: translateY(6px); }
                    to { opacity: 1; transform: translateY(0); }
                }
                .cursor-pointer { cursor: pointer; }
                .form-control:focus {
                    border-color: #7a3a5e !important;
                    box-shadow: 0 0 0 3px rgba(122, 58, 94, 0.12) !important;
                }
            `}</style>
        </div >
    );
};

// {
//     dashboardLabel?.toLowerCase()?.split(" ")?.join("_") === "my_taskboard" &&
//         <div className=" position-relative " >
//             <input
//                 type="text"
//                 className="btn d-flex align-items-start border gap-2  py-2 transition-all"
//                 style={{ fontSize: "0.87rem", fontWeight: 500, textAlign: "left", paddingLeft: "36px", height: '38px', borderRadius: "16px", background: "white" }}
//                 value={inputSearch}
//                 placeholder="Search Here...."
//                 onChange={(e) => {
//                     e.preventDefault()
//                     setInputSearch(e.target.value)
//                 }}
//                 onKeyDown={(e) => {
//                     if (e.key === "Enter") {
//                         e.preventDefault()
//                         setInputSearch(inputSearch)
//                     }
//                 }}
//             />
//             <i
//                 class="fa-solid fa-magnifying-glass"
//                 style={{
//                     position: "absolute",
//                     marginTop: "-26px",
//                     zIndex: 1,
//                     marginLeft: "13px",
//                 }}
//             ></i>
//             {inputSearch.length > 0 && (
//                 <i
//                     class="fa-solid fa-xmark"
//                     style={{
//                         position: "absolute",
//                         marginTop: "-26px",
//                         zIndex: 1,
//                         right: 0,
//                         marginRight: "13px",
//                         cursor: "pointer",
//                     }}
//                 // onClick={() => setInputSearch("")}
//                 ></i>
//             )}
//         </div>

// }
// }
